import WhatsNewDialog from 'screens/whats-new-dialog';
import LoginScreen from './login';
import ContractsScreen from './contracts';
import DataCentersScreen from './data-centers';
import DataCenterScreen from './data-center';
import ServerScreen from './server';
import StorageScreen from './storage';
import LanScreens from './lan';
import NICScreen from './nic';
import LanguageScreen from './language';
import SSHKeysScreen from './ssh-keys';
import ImagesScreen from './images';
import UserManagementScreen from './user-management';
import UserManagementGroupsScreen from './user-management/groups';
import UserManagementUsersScreen from './user-management/users';
import GroupSingleScreen from './user-management/groups/item';
import UserSingleScreen from './user-management/users/item';
import Shared from './shared';
import Kubernetes from './kubernetes';
import Loadbalancer from './load-balancer';
import IPs from './ips';
import Graph from './graph';
import BackupUnits from './backup-units';
import NLB from './nlb';
import ALB from './alb';
import Invoice from './invoice';
import Monitoring from './monitoring';
import AutoScaling from './auto-scaling';
import NatGateway from './nat-gateway';
import CertificateManager from './certificate-manager';
import TargetGroups from './target-groups';
import Databases from './databases';
import Sample from './sample';
import DcdLoginError from './dcd-login-error';
import { Configuration } from './configuration';
import ContainerRegistry from './container-registry';

export default {
  LoginScreen,
  ContractsScreen,
  DataCentersScreen,
  DataCenterScreen,
  ServerScreen,
  StorageScreen,
  LanScreens,
  LanguageScreen,
  NICScreen,
  SSHKeysScreen,
  ImagesScreen,
  UserManagementScreen,
  UserManagementGroupsScreen,
  UserManagementUsersScreen,
  GroupSingleScreen,
  UserSingleScreen,
  Shared,
  Kubernetes,
  Loadbalancer,
  IPs,
  Graph,
  BackupUnits,
  NLB,
  ALB,
  Invoice,
  Monitoring,
  AutoScaling,
  NatGateway,
  CertificateManager,
  TargetGroups,
  Databases,
  Sample,
  WhatsNewDialog,
  DcdLoginError,
  Configuration,
  ContainerRegistry,
};
